module.exports = __webpack_public_path__ + "67a4a5eb6fcfbd8ad0e1989567cfa72b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/mobile-chart.svg
// module id = 80
// module chunks = 0